export default __webpack_public_path__ + "static/media/Mali.9e10eda9.png";